export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const apiImageUrl = process.env.REACT_APP_API_BASE_IMG_URL;


